import React from "react";
import Caminho from "../assets/Caminho.jpeg";

const CaminhoPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6">
      {/* Contêiner principal */}
      <div className="flex flex-col md:flex-row items-center max-w-4xl w-full">
        {/* Imagem (sempre centralizada) */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src={Caminho}
            alt="Caminho"
            className="w-full h-auto rounded-lg shadow-lg"
          />
        </div>

        {/* Texto (sempre centralizado) */}
        <div className="w-full md:w-1/2 mt-6 md:mt-0 md:pl-8 text-center">
          <h1 className="text-3xl font-bold text-[#ad6a51] mb-4">
            Tá tudo bem mudar no meio do caminho
          </h1>
          <p className="text-lg text-[#4a4a4a] leading-relaxed">
            Você já parou pra pensar em como tem lidado com suas escolhas? Você
            se permite mudar, ou segue rigidamente aquele caminho até o final do
            processo?
            <br />
            <br />
            Às vezes, deixamos de fazer mudanças em nossas vidas, por medo de
            apontarem isso como fraqueza, indecisão ou falta de persistência da
            nossa parte. Porém, mudanças também são necessárias para nosso
            processo de amadurecimento, da busca pela nossa felicidade e para as
            próprias conquistas. Está tudo bem mudar, quando percebemos que é o
            melhor e mais saudável a se fazer por nós mesmos.
            <br />
            <br />
            Você tem conseguido aplicar mudanças em sua vida sem culpa?
          </p>
        </div>
      </div>
    </div>
  );
};

export default CaminhoPage;
